export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Contained"] = "contained";
    ButtonVariant["Outlined"] = "outlined";
    ButtonVariant["Ghost"] = "ghost";
})(ButtonVariant || (ButtonVariant = {}));
export var ButtonShape;
(function (ButtonShape) {
    ButtonShape["Default"] = "default";
    ButtonShape["Icon"] = "icon";
    ButtonShape["Pill"] = "pill";
    ButtonShape["Rounded"] = "rounded";
})(ButtonShape || (ButtonShape = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["Button"] = "button";
    ButtonType["Submit"] = "submit";
    ButtonType["Reset"] = "reset";
})(ButtonType || (ButtonType = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "small";
    ButtonSize["Large"] = "large";
    ButtonSize["Responsive"] = "responsive";
    ButtonSize["ResponsiveXs"] = "responsiveXs";
})(ButtonSize || (ButtonSize = {}));
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Brand"] = "brand";
    ButtonColor["BrandDark"] = "brandDark";
    ButtonColor["Club"] = "club";
    ButtonColor["Complementary"] = "complementary";
    ButtonColor["Dark"] = "dark";
    ButtonColor["White"] = "white";
    ButtonColor["Grey"] = "grey";
    ButtonColor["Highlight"] = "highlight";
})(ButtonColor || (ButtonColor = {}));
